// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"255":"23853b1e","295":"4a34bf45"}[chunkId] + ".css";
};